import React from 'react'
import { NavLink } from 'react-router-dom'
import jiminsproduction from '../image/jiminsproduction.webp'

const Varietydetails1 = () => {
  return (
    <div>
        <div className="bg-gradient-to-r from-pink-200 to-fuchsia-100 overflow-hidden h-screen">
      <NavLink to="https://www.youtube.com/watch?v=RGYkRNdsd1Y"> <a class="group sm:flex rounded-xl dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600 p-5" href="https://www.youtube.com/watch?v=RGYkRNdsd1Y">
      <div class="flex-shrink-0 relative rounded-xl overflow-hidden w-full h-[200px] sm:w-[250px] sm:h-[350px]">
        <img class="w-full h-full absolute top-0 start-0 object-cover" src={jiminsproduction} alt="Image Description"/>
      </div>
      <div class="grow">
        <div class="p-4 flex flex-col h-full sm:p-6">
          <div class="mb-3">
            <p class="inline-flex items-center gap-1.5 py-1.5 px-3 rounded-md text-xs font-medium bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200">
            Documentary
            </p>
          </div>
          <h3 class="text-lg sm:text-2xl font-semibold text-purple-500 group-hover:text-blue-600 dark:text-gray-300 dark:group-hover:text-white">
          Jimin's Production Diary
          </h3>
          <div className='border-2 p-2 border-blue-300 hover:border-purple-400 rounded-lg mt-3'>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Genres: </span>Documentary
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Release Date: </span> October 23, 2023
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md '>Episode: </span>TBD
          </p>
          </div>
        </div>
      </div>
    </a> </NavLink>
    <hr class="border-purple-500 mt-5"></hr>

<div>
  <div className='flex justify-center'>
     <h1 className='font-bold text-2xl p-2 text-blue-500'>About the show</h1>
  </div>
  <div className='p-5 text-lg font-semibold text-gray-500'>
      <p>On October 9, 2023, BigHit shared a video clip of Jimin writing a special letter to ARMYs announcing his first solo documentary titled 'Jimin's Production Diary' at which will provide fans an intimate look into Jimin's creative journey making his solo album, 'FACE.'</p>
  </div>
  <div className='p-5 text-lg font-semibold text-gray-500'>
      <p>The documentary will be available on Weverse beginning on October 23, 2023 @ 6pm KST. </p>
  </div>
  <div className='p-5 text-lg font-semibold text-gray-500'>
      <p>Additional information will be posted here as it comes available.</p>
  </div>
  <div className='text-2xl font-bold text-blue-500 p-4'>
    EPISODES
    </div>
    <div className='text-purple-500 text-xl font-semibold p-1 ml-7'>
        <p>Dec 23, 2023: Ep 1 & 2 at 12 am PT/3am ET</p>
<p>Dec 24, 2023: Ep 3 & 4 at 12 am PT/3am ET</p>
<p>Jan 1, 2024:   Ep 5 & 6 at 12 am PT/3am ET</p>
<p>Jan 12, 2024: Ep 7 & 8 at 12 am PT/3am ET</p>
    </div>
</div>
    </div>
    </div>
  )
}

export default Varietydetails1
